import { render, staticRenderFns } from "./DialogoBuscarComponentes.vue?vue&type=template&id=4c256c22&scoped=true&"
import script from "./DialogoBuscarComponentes.vue?vue&type=script&lang=js&"
export * from "./DialogoBuscarComponentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c256c22",
  null
  
)

export default component.exports